import { createServerFn } from '@tanstack/react-start';

import type { AuthSession } from '~/modules/auth/types.ts';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

export interface UserSettingsPageData {
	readonly authSession: AuthSession;
}

export const getUserSettingsPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session'],
			relatesTo: 'user.settings',
		}),
	])
	.handler(async (): Promise<UserSettingsPageData> => {
		const authSession = await requireStartAuthSession();

		return {
			authSession,
		};
	});
